import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { BodyShort01 } from 'ozone/atoms';
import { BillabliltyChart } from './billability-chart';
import { CategoriesChart } from './categories-chart';
import { Summary } from './summary';

export const HeaderSummary = styled.section`
  padding: var(--layout-02) var(--layout-03);
  display: flex;
`;

export const BillabilitySummary = styled(BillabliltyChart)`
  margin-right: 100px;
`;

export const MetricSummary = styled(Summary)`
  margin-right: var(--spacing-06);
`;

export const CategoriesSummaryChart = styled(CategoriesChart)`
  height: 26px;
`;

export const BlueGhostButton = styled(Button).attrs({ type: 'text' })`
  color: var(--blue-60);
`;

export const DeleteButton = styled(Button).attrs({ type: 'text' })`
  color: var(--black-100);
  &:hover,
  &:focus {
    color: var(--red-60);
  }
`;

export const EditButton = styled(Button).attrs({ type: 'link' })`
  color: var(--gray-70);
  &:hover,
  &:focus {
    color: var(--blue-60);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const BodyWrapper = styled.section`
  padding: 0 var(--layout-01);
  padding-left: var(--left-spacing);
  width: 100%;
  flex: 1;
  position: relative;
  overflow-y: auto;
`;

export const Footer = styled.div`
  padding: 0 var(--layout-01);
  padding-left: var(--left-spacing);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const FooterActionRow = styled.div<{ isUserApproverView?: boolean }>`
  display: flex;
  padding: var(--spacing-04) 0;
  justify-content: flex-end;
  align-items: center;
  background: var(--white-100);
  padding-bottom: ${({ isUserApproverView }) =>
    isUserApproverView && 'var(--spacing-04)'};

  ${Button} {
    margin-left: 8px;
    height: var(--spacing-07);
  }

  ${BodyShort01} {
    margin-right: 24px;
  }
`;
